import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

export const AnnouncementsTab = ({ value, onChange }) => {
  const list = value.announcements || [];
  const setList = (arr) => onChange({ ...value, announcements: arr });
  const patch = (idx, p) => setList(list.map((a, i) => (i === idx ? { ...a, ...p } : a)));

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">Panel üst barında kayan duyurular.</p>
        <Button type="button" size="sm" variant="outline" onClick={() => setList([...list, { title: '', text: '', active: true }])} data-testid="add-announcement-btn">+ Duyuru Ekle</Button>
      </div>
      {list.length === 0 && <p className="text-xs text-slate-400 italic">Henüz duyuru yok.</p>}
      {list.map((a, idx) => (
        <div key={idx} className="border rounded-lg p-3 space-y-2" data-testid={`announcement-${idx}`}>
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-bold text-slate-400">DUYURU #{idx + 1}</span>
            <div className="flex items-center gap-2">
              <label className="flex items-center gap-1 text-xs cursor-pointer">
                <input type="checkbox" checked={a.active !== false} onChange={e => patch(idx, { active: e.target.checked })} className="accent-emerald-600" />
                Yayında
              </label>
              <button type="button" onClick={() => setList(list.filter((_, i) => i !== idx))} className="text-red-500 hover:bg-red-50 px-1.5 rounded" data-testid={`del-announcement-${idx}`}>✕</button>
            </div>
          </div>
          <Input value={a.title || ''} onChange={e => patch(idx, { title: e.target.value })} placeholder="Başlık (örn. Önemli)" />
          <Input value={a.text || ''} onChange={e => patch(idx, { text: e.target.value })} placeholder="Duyuru metni..." />
        </div>
      ))}
      <p className="text-[10px] text-slate-500">Birden fazla duyuru 8 saniyede bir döner.</p>
    </div>
  );
};
